var map = {
	"./icon_employees.png": "c3ae",
	"./icon_employees_en.png": "6245",
	"./icon_employees_es.png": "9954",
	"./icon_employees_hk.png": "d552",
	"./icon_employees_pt.png": "4c5f",
	"./icon_employees_tr.png": "ff52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e33";